module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/transform.js
// module id = 769
// module chunks = 0